import { FC } from "react";

import { Box } from "@mui/material";

import { LayoutProps } from "./type";

export const MinimalLayout: FC<LayoutProps & { hideBackground?: boolean }> = ({ children, hideBackground }) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100dvh",
        backgroundColor: hideBackground ? undefined : "#ffffff",
      }}
    >
      {children}
    </Box>
  );
};
